import { adaptMapBounds, mapMap, SearchMigrationAdapter } from 'src/common/stores/adapters/bex-api';

import { HotelResultsViewModel } from 'models';

import { OperationResult } from '__generated__/api/api-operations';
import { PropertyMapMigration } from '__generated__/api';

export const adaptMap: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;

  if (!propertySearch || !propertySearch.map) {
    return bffResults;
  }

  return {
    ...bffResults,
    map: mapMap(data)
  };
};

export const adaptStaticMapSrc: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;

  if (!propertySearch || !propertySearch.map || !propertySearch.map.staticMapSrc) {
    return bffResults;
  }

  return {
    ...bffResults,
    map: {
      ...bffResults.map,
      staticMapSrc: propertySearch.map.staticMapSrc
    }
  };
};

export const adaptMapBoundsAndCenter: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;

  if (!propertySearch || !propertySearch.map) {
    return bffResults;
  }

  const { map } = propertySearch;

  return {
    ...bffResults,
    map: {
      ...bffResults.map,
      title: map.title,
      ...adaptMapBounds(data)
    }
  };
};
